<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="495px"
    :close-on-click-modal="false"
    @close="$router.replace('/todo-recurring-patterns')"
  >
    <el-form
      ref="patternForm"
      v-loading="loading"
      :model="pattern"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="interval"
            label="Ismétlődés intervallum"
          >
            <el-input
              v-model="pattern.interval"
              class="input-with-select"
            >
              <el-select
                slot="append"
                v-model="pattern.interval_type"
                style="width: 100px"
              >
                <el-option
                  label="hetente"
                  value="week"
                />
                <el-option
                  label="havonta"
                  value="month"
                />
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-if="pattern.interval_type === 'month'"
            prop="day_of_month"
            label="Hányadikán jöjjön létre a todo?"
          >
            <el-select
              v-model="pattern.day_of_month"
              style="width: 100%;"
            >
              <el-option
                v-for="day in days"
                :key="day + 1"
                :label="`${day + 1}.`"
                :value="day + 1"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="pattern.interval_type === 'week'"
            prop="day_of_week"
            label="Melyik napon jöjjön létre a todo?"
          >
            <el-select
              v-model="pattern.day_of_week"
              style="width: 100%;"
            >
              <el-option
                label="Hétfő"
                :value="1"
              />
              <el-option
                label="Kedd"
                :value="2"
              />
              <el-option
                label="Szerda"
                :value="3"
              />
              <el-option
                label="Csütörtök"
                :value="4"
              />
              <el-option
                label="Péntek"
                :value="5"
              />
              <el-option
                label="Szombat"
                :value="6"
              />
              <el-option
                label="Vasárnap"
                :value="7"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        prop="recurring_deadline"
        label="Létrehozástól számított határidő"
      >
        <el-input
          v-model="pattern.recurring_deadline"
          class="input-with-select"
        >
          <el-select
            slot="append"
            v-model="pattern.recurring_deadline_type"
            style="width: 150px"
          >
            <el-option
              label="nap"
              value="day"
            />
            <el-option
              label="hét"
              value="week"
            />
            <el-option
              label="hónap"
              value="month"
            />
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item
        prop="expiration"
        label="Ismétlődés érvényessége"
      >
        <el-date-picker
          v-model="pattern.expiration"
          type="daterange"
          format="yyyy. MM. dd."
          value-format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item
        prop="subscribers"
        label="Feliratkozók"
      >
        <el-select
          v-model="pattern.subscribers"
          style="width: 100%;"
          filterable
          multiple
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="`${user.last_name} ${user.first_name} (@${user.username})`"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/todo-recurring-patterns')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'patternId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      days: [...Array(28).keys()],
      pattern: {
        interval: 1,
        interval_type: 'month',
      },
      rules: {
        recurring_deadline: [
          {
            required: true,
            message: 'Határidő megadása kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új todo szabály';
      } else if (this.type === 'update') {
        return 'Todo szabály módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    if (!this.users.length) {
      await this.$store.dispatch('user/fetchAll');
    }
    if (this.patternId) {
      this.pattern = await this.$store.dispatch('todoRecurringPattern/fetch', this.patternId);
      this.pattern.subscribers = this.pattern.subscribers.map(s => s.id);
      this.pattern.expiration = [this.pattern.from, this.pattern.to];
    }
    this.loading = false;
  },
  methods: {
    async store() {
      this.$refs['patternForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          this.pattern.from = this.pattern.expiration[0];
          this.pattern.to = this.pattern.expiration[1];
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('todoRecurringPattern/create', this.pattern);
            } else if (this.type === 'update') {
              await this.$store.dispatch('todoRecurringPattern/update', this.pattern);
            }
            this.$store.dispatch('todoRecurringPattern/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/todo-recurring-patterns');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    }
  },
};
</script>
